import React, { memo } from "react";
import { Outlet, useOutletContext } from "react-router-dom";

import Sidebar from "../Layouts/Sidebar";
import Topbar from "./Topbar";
import { useSelector } from "react-redux";
import BottomMenu from "./BottomMenu";

const Master = () => {
  const isLoading = useSelector((state) => state.ui?.isLoading);
  const { isAuthChecking } = useOutletContext() || {};

  return (
    <>
      <Topbar />
      <Sidebar />

      <section className="main-content">
        {/* {isAuthChecking && <h1>Loading ROUTE</h1>} */}
        <Outlet />
      </section>

      <BottomMenu />
    </>
  );
};

export default memo(Master);
